import * as React from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import colorSchemes from "../../../constants/colorSchemes";
import routes from "../../../constants/routes";
import useStyles from "./SignIn.styles";
import "react-toastify/dist/ReactToastify.css";
import { removeToken, removeUserData, getUserData } from "../../../common";
import LogoutIcon from "@mui/icons-material/Logout";
import { isEmpty } from "lodash";
import LoginForm from "./LoginForm";

export default function SignIN() {
  const navigate = useNavigate();
  const classes = useStyles();

  const userData = getUserData() ?? {};

  return (
    <Box className={classes.signin}>
      {isEmpty(userData) ? (
        <Card
          sx={{ maxWidth: 500, marginTop: "9em", padding: "1em 2em" }}
          className={classes.signcard}
        >
          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "600",
                color: colorSchemes.primaryColor,
              }}
              variant="h5"
            >
              LOGIN
            </Typography>
          </Box>
          <LoginForm
            onSuccess={() => {
              setTimeout(() => {
                navigate(routes.home);
              }, 1500);
            }}
          />
        </Card>
      ) : (
        <Card
          sx={{ maxWidth: 500, marginTop: "9em", padding: "3.5em 2em" }}
          className={classes.signcard}
        >
          <center className="tabHead">
            <h3>Your Already Logged in!</h3>
            <Button
              sx={{
                backgroundColor: colorSchemes.primaryColor,
                color: "#fff",
                borderRadius: "0em",
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "#2D55EB !important",
                },
              }}
              onClick={() => {
                removeToken();
                removeUserData();
                navigate(routes.signin);
              }}
              fullWidth
              type="submit"
            >
              <LogoutIcon
                sx={{
                  color: "white",
                  fontSize: "16px",
                  marginTop: "-2px",
                  marginRight: "5px",
                }}
              />
              Log Out
            </Button>
          </center>
        </Card>
      )}
    </Box>
  );
}
